/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1C3DInfos } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt, FaSync, FaQrcode } from 'react-icons/fa';
import { generateMRZ_TD1 } from '../utils/mrzGenerator';
import IframeModal from '../components/IframeModal/IframeModal';
import vietnamAddressData from '../utils/vietnamAddressBefore2024.json';
import C3DInfoModal from '../components/C3DInfoModal/C3DInfoModal';
import { getApiUrl } from '../utils/platform';
import { getToken } from '../utils/token';
import { QRCodeSVG } from 'qrcode.react';

class TKT1C3DInfo extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'created_at',
    sortOrder: -1,
    search: '',
    search_exact: false,
    province: ''
  }

  initShowColumns = {
    full_name: true,
    full_name_english: false,
    c3d_number: true,
    c3d_dob: true,
    c3d_sex: true,
    c3d_place_of_origin: false,
    c3d_place_of_residence: true,
    c3d_city: true,
    tax_city: true,
    source: false,
    info_etsy_status: false,
    ref_trusted_person_mid: false,
    ref_etsy_info_pack_mid: true,
    cmt_number: false,
    c3d_issue_date: false,
    c3d_expired_date: false
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns, // Separate showColumns from query
      loading: false,
      showConfigModal: false,
      search_exact: false,
      showEditModal: false,
      showViewModal: false,
      showCreateModal: false,
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: '',
      selectedC3DInfo: null,
      isEditMode: false,
      showQRModal: false,
      ref_trusted_person_mid: null, // Store ref_trusted_person_mid from URL
      checkedTaxC3Ds: new Set(), // Store checked C3D numbers
      editFormData: {
        full_name: '',
        full_name_english: '',
        c3d_number: '',
        c3d_dob: '',
        c3d_sex: 'MALE',
        c3d_place_of_origin: '',
        c3d_place_of_residence: '',
        c3d_city: '',
        source: 'MANUAL',
        info_etsy_status: 'NO_TAX_INFO',
        ref_trusted_person_mid: '',
        ref_etsy_info_pack_mid: '',
        cmt_number: '',
        c3d_issue_date: '',
        c3d_expired_date: ''
      },
      createFormData: {
        full_name: '',
        full_name_english: '',
        c3d_number: '',
        c3d_dob: '',
        c3d_sex: 'MALE',
        c3d_place_of_origin: '',
        c3d_place_of_residence: '',
        c3d_city: '',
        source: 'MANUAL',
        info_etsy_status: 'NO_TAX_INFO',
        ref_trusted_person_mid: '',
        ref_etsy_info_pack_mid: '',
        cmt_number: '',
        c3d_issue_date: '',
        c3d_expired_date: ''
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 C3D Database';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Extract ref_trusted_person_mid from URL but don't include in query
      const refTrustedPersonMid = queryObject.ref_trusted_person_mid;
      delete queryObject.ref_trusted_person_mid; // Remove from query object
      
      // Parse numeric values
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      // Parse boolean values
      if (queryObject.search_exact !== undefined) {
        queryObject.search_exact = queryObject.search_exact === 'true';
      }
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1C3DInfo_ViewConfig'));
      
      // Use search_exact from URL if present, otherwise from localStorage
      const searchExact = queryObject.search_exact !== undefined 
        ? queryObject.search_exact 
        : JSON.parse(localStorage.getItem('TKT1C3DInfo_search_exact')) || false;
      
      // Load checked tax C3Ds from localStorage
      const checkedTaxC3Ds = JSON.parse(localStorage.getItem('TKT1C3DInfo_checkedTaxC3Ds')) || [];
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      // If ref_trusted_person_mid exists in URL, always set itemsPerPage to 9999 for full display
      if (refTrustedPersonMid) {
        restoredQuery.itemsPerPage = 9999;
        console.log('Setting itemsPerPage to 9999 due to refTrustedPersonMid:', refTrustedPersonMid);
      }

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        },
        search_exact: searchExact,
        ref_trusted_person_mid: refTrustedPersonMid,
        checkedTaxC3Ds: new Set(checkedTaxC3Ds)
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1C3DInfos(apiQuery);
      })
    } else {
      // No URL params - use localStorage for other fields, but NOT itemsPerPage
      var query = JSON.parse(localStorage.getItem('tkt1_c3d_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1C3DInfo_ViewConfig'));
      var searchExact = JSON.parse(localStorage.getItem('TKT1C3DInfo_search_exact')) || false;
      var checkedTaxC3Ds = JSON.parse(localStorage.getItem('TKT1C3DInfo_checkedTaxC3Ds')) || [];
      
      console.log('No URL params, using localStorage query:', query);
      
      // Clear any refTrustedPersonMid from localStorage if not in URL
      if (query && query.refTrustedPersonMid) {
        delete query.refTrustedPersonMid;
        localStorage.setItem('tkt1_c3d_query', JSON.stringify(query));
        console.log('Cleared refTrustedPersonMid from localStorage');
      }
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        // Don't use itemsPerPage from localStorage, use default value
        restored.itemsPerPage = this.initQuery.itemsPerPage;
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          search_exact: searchExact,
          checkedTaxC3Ds: new Set(checkedTaxC3Ds)
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1C3DInfos(apiQuery);
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          search_exact: searchExact,
          checkedTaxC3Ds: new Set(checkedTaxC3Ds)
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1C3DInfos(apiQuery);
        })
      }
    }
  }

  componentWillReceiveProps(props) {
    // No need to update state since we're using props directly
    // This method can be removed or kept for future use
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_c3d_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      province: this.state.query.province
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1C3DInfos(apiQuery);
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_c3d_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      province: this.state.query.province
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1C3DInfos(apiQuery);
  }

  handleSearchExactChange = (e) => {
    const searchExact = e.target.checked;
    this.setState({ search_exact: searchExact });
    localStorage.setItem('TKT1C3DInfo_search_exact', JSON.stringify(searchExact));
  }

  handleProvinceChange = (e) => {
    const newQuery = { ...this.state.query, province: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_c3d_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      province: newQuery.province
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1C3DInfos(apiQuery);
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      // Save view config separately - not related to query
      localStorage.setItem('TKT1C3DInfo_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  // Map gender from English to Vietnamese
  mapGender = (gender) => {
    if (!gender) return '-';
    switch (gender.toUpperCase()) {
      case 'MALE':
        return 'Nam';
      case 'FEMALE':
        return 'Nữ';
      default:
        return gender;
    }
  }

  // Map Etsy status to Vietnamese
  mapEtsyStatus = (status) => {
    if (!status) return '-';
    switch (status.toUpperCase()) {
      case 'NO_TAX_INFO':
        return 'Chưa có thông tin thuế';
      case 'WAIT_FOR_TRUSTED_INFO':
        return 'Chờ thông tin người tin cậy';
      case 'FOUND_TRUSTED_INFO':
        return 'Đã tìm thấy người tin cậy';
      case 'REGISTERED':
        return 'Đã đăng ký';
      case 'SUSPENDED':
        return 'Bị tạm dừng';
      case 'CANCEL':
        return 'Đã hủy';
      default:
        return status;
    }
  }

  // Extract tax cities from DN_tax_infos and TNCN_tax_infos
  getTaxCities = (info) => {
    if (!info) return '-';
    
    const cities = new Set();
    
    // Extract cities from DN_tax_infos
    if (info.DN_tax_infos && Array.isArray(info.DN_tax_infos)) {
      info.DN_tax_infos.forEach(taxInfo => {
        if (taxInfo.city && taxInfo.city.trim()) {
          cities.add(taxInfo.city.trim());
        }
      });
    }
    
    // Extract cities from TNCN_tax_infos
    if (info.TNCN_tax_infos && Array.isArray(info.TNCN_tax_infos)) {
      info.TNCN_tax_infos.forEach(taxInfo => {
        if (taxInfo.city && taxInfo.city.trim()) {
          cities.add(taxInfo.city.trim());
        }
      });
    }
    
    return cities.size > 0 ? Array.from(cities).join(' | ') : '-';
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      // You could add a toast notification here if needed
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Format date to DD/MM/YYYY, handling both ISO strings and DD/MM/YYYY strings
  formatDate = (dateString) => {
    if (!dateString) return '-';
    
    // If already in DD/MM/YYYY format, return as is
    if (typeof dateString === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      return dateString;
    }
    
    // Try to parse as ISO date or other formats
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString; // Return original if can't parse
      }
      
      // Convert to Hanoi timezone (UTC+7) for display
      const hanoiDate = new Date(date.getTime() + (7 * 60 * 60 * 1000));
      return hanoiDate.toLocaleDateString('en-GB');
    } catch (error) {
      return dateString; // Return original if error
    }
  }

  // Format date for HTML date input (YYYY-MM-DD), handling timezone conversion
  formatDateForInput = (dateString) => {
    if (!dateString) return '';
    
    // If already in DD/MM/YYYY format, convert to YYYY-MM-DD
    if (typeof dateString === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      const [day, month, year] = dateString.split('/');
      return `${year}-${month}-${day}`;
    }
    
    // Try to parse as ISO date or other formats
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return ''; // Return empty if can't parse
      }
      
      // Convert to Hanoi timezone (UTC+7) for input
      const hanoiDate = new Date(date.getTime() + (7 * 60 * 60 * 1000));
      return hanoiDate.toISOString().split('T')[0];
    } catch (error) {
      return ''; // Return empty if error
    }
  }

  // Generate QR code data for C3D info
  generateQRData = (c3dInfo) => {
    if (!c3dInfo) return '';

    const formatDate = (dateString) => {
      if (!dateString) return '';
      
      // Handle different date formats
      if (dateString.includes('/')) {
        // Format: "29/07/1997" -> "29071997"
        return dateString.replace(/\//g, '');
      } else {
        // Format: ISO string -> "ddmmyyyy"
        try {
          const date = new Date(dateString);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear().toString();
          return `${day}${month}${year}`;
        } catch (error) {
          console.error('Error formatting date:', error);
          return '';
        }
      }
    };

    const formatGender = (gender) => {
      if (!gender) return '';
      switch (gender.toUpperCase()) {
        case 'MALE':
          return 'Nam';
        case 'FEMALE':
          return 'Nữ';
        default:
          return gender;
      }
    };

    const c3d_number = c3dInfo.c3d_number || '';
    const cmt_number = c3dInfo.cmt_number || '';
    const full_name = c3dInfo.full_name || '';
    const dob = formatDate(c3dInfo.c3d_dob);
    const sex = formatGender(c3dInfo.c3d_sex);
    const place_of_origin = c3dInfo.c3d_place_of_origin || '';
    const issue_date = formatDate(c3dInfo.c3d_issue_date);

    const qrData = `${c3d_number}|${cmt_number}|${full_name}|${dob}|${sex}|${place_of_origin}|${issue_date}||||`;
    console.log('Generated QR Data:', qrData); // Debug log
    return qrData;
  }

  // Generate MRZ TD1 (3x30) for C3D info using utility function
  generateMRZ = (c3dInfo) => {
    if (!c3dInfo || !c3dInfo.c3d_number) {
      console.log('MRZ Error: Missing c3dInfo or c3d_number');
      return null;
    }

    try {
      const cccd12 = c3dInfo.c3d_number;
      const name = c3dInfo.full_name || '';
      const dob = c3dInfo.c3d_dob || '';
      const sex = c3dInfo.c3d_sex === 'FEMALE' ? 'F' : 'M';
      const expiry = c3dInfo.c3d_expired_date || '';
      const issuingCountry = 'VNM';

      console.log('MRZ Input Data:', { cccd12, name, dob, sex, expiry });

      const mrz = generateMRZ_TD1({
        cccd12,
        name,
        dob,
        sex,
        expiry,
        issuingCountry
      });

      console.log('MRZ Generated Successfully:', mrz);
      return mrz;
    } catch (error) {
      console.error('Error generating MRZ:', error);
      console.error('C3D Info:', c3dInfo);
      return null;
    }
  }

  // Download QR code as PNG with transparent background
  downloadQRAsPNG = () => {
    const qrContainer = document.getElementById('qr-code-container');
    const svgElement = qrContainer?.querySelector('svg');
    
    if (!svgElement) {
      alert('Không tìm thấy QR code để download!');
      return;
    }

    try {
      // Clone the SVG element to modify it
      const clonedSvg = svgElement.cloneNode(true);
      
      // Remove any background fill or set it to transparent
      const rects = clonedSvg.querySelectorAll('rect');
      rects.forEach(rect => {
        if (rect.getAttribute('fill') === '#ffffff' || rect.getAttribute('fill') === 'white') {
          rect.setAttribute('fill', 'transparent');
        }
      });
      
      // Set SVG background to transparent
      clonedSvg.setAttribute('style', 'background: transparent;');
      clonedSvg.style.backgroundColor = 'transparent';
      
      // Get SVG data
      const svgData = new XMLSerializer().serializeToString(clonedSvg);
      
      // Create canvas with transparent background
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d', { alpha: true });
      
      // Set canvas size (higher resolution)
      const size = 300; // Higher resolution for better quality
      canvas.width = size;
      canvas.height = size;
      
      // Ensure transparent background
      ctx.clearRect(0, 0, size, size);
      ctx.fillStyle = 'transparent';
      ctx.fillRect(0, 0, size, size);
      
      // Create image from SVG
      const img = new Image();
      const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(svgBlob);
      
      img.onload = () => {
        // Draw image on canvas with transparent background
        ctx.drawImage(img, 0, 0, size, size);
        
        // Convert to PNG and download
        canvas.toBlob((blob) => {
          const link = document.createElement('a');
          const fileName = `QR_${this.state.selectedC3DInfo.c3d_number || 'C3D'}_${new Date().getTime()}.png`;
          
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          // Clean up
          URL.revokeObjectURL(url);
          URL.revokeObjectURL(link.href);
          
          alert('Đã download QR code thành công!');
        }, 'image/png');
      };
      
      img.onerror = () => {
        alert('Lỗi khi tạo QR code PNG!');
        URL.revokeObjectURL(url);
      };
      
      img.src = url;
      
    } catch (error) {
      console.error('Error downloading QR code:', error);
      alert('Lỗi khi download QR code!');
    }
  }

  // Handle QR code modal
  handleQRClick = (c3dInfo) => {
    console.log('QR Click triggered for:', c3dInfo); // Debug log
    this.setState({
      showQRModal: true,
      selectedC3DInfo: c3dInfo
    });
  }

  handleCloseQRModal = () => {
    this.setState({
      showQRModal: false,
      selectedC3DInfo: null
    });
  }

  // Handle tax icon click - mark as checked and open link
  handleTaxIconClick = (c3Number) => {
    if (c3Number) {
      // Mark as checked
      const newCheckedTaxC3Ds = new Set(this.state.checkedTaxC3Ds);
      newCheckedTaxC3Ds.add(c3Number);
      
      // Save to localStorage
      localStorage.setItem('TKT1C3DInfo_checkedTaxC3Ds', JSON.stringify(Array.from(newCheckedTaxC3Ds)));
      
      // Update state
      this.setState({ checkedTaxC3Ds: newCheckedTaxC3Ds });
      
      // Open tax lookup link
      this.openTaxKDLink(c3Number);
    }
  }

  // Open tax lookup links
  openTaxKDLink = (c3Number) => {
    if (c3Number) {
      let url = `https://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=${c3Number}`;
      
      // Add ref_trusted_person_mid if available from URL
      if (this.state.ref_trusted_person_mid) {
        url += `&ref_trusted_person_mid=${this.state.ref_trusted_person_mid}`;
      }
      
      window.open(url, '_blank');
    }
  }

  openTaxTNCNLink = (c3dNumber) => {
    if (c3dNumber) {
      let url = `https://tracuunnt.gdt.gov.vn/tcnnt/mstcn.jsp?mst=${c3dNumber}`;
      
      // Add ref_trusted_person_mid if available from URL
      if (this.state.ref_trusted_person_mid) {
        url += `&ref_trusted_person_mid=${this.state.ref_trusted_person_mid}`;
      }
      
      window.open(url, '_blank');
    }
  }

  // Modal handlers
  handleViewClick = (c3dInfo) => {
    this.setState({
      showViewModal: true,
      selectedC3DInfo: c3dInfo,
      isEditMode: false
    });
  }

  handleEditClick = (c3dInfo) => {
    this.setState({
      showEditModal: true,
      selectedC3DInfo: c3dInfo,
      isEditMode: true,
      editFormData: {
        full_name: c3dInfo.full_name || '',
        full_name_english: c3dInfo.full_name_english || '',
        c3d_number: c3dInfo.c3d_number || '',
        c3d_dob: c3dInfo.c3d_dob || '',
        c3d_sex: c3dInfo.c3d_sex || 'MALE',
        c3d_place_of_origin: c3dInfo.c3d_place_of_origin || '',
        c3d_place_of_residence: c3dInfo.c3d_place_of_residence || '',
        c3d_city: c3dInfo.c3d_city || '',
        source: c3dInfo.source || 'MANUAL',
        info_etsy_status: c3dInfo.info_etsy_status || 'NO_TAX_INFO',
        ref_trusted_person_mid: c3dInfo.ref_trusted_person_mid || '',
        ref_etsy_info_pack_mid: c3dInfo.ref_etsy_info_pack_mid || '',
        cmt_number: c3dInfo.cmt_number || '',
        c3d_issue_date: c3dInfo.c3d_issue_date || '',
        c3d_expired_date: c3dInfo.c3d_expired_date || ''
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedC3DInfo: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedC3DInfo: null,
      isEditMode: false
    });
  }

  handleCreateClick = () => {
    this.setState({
      showCreateModal: true,
      createFormData: {
        full_name: '',
        full_name_english: '',
        c3d_number: '',
        c3d_dob: '',
        c3d_sex: 'MALE',
        c3d_place_of_origin: '',
        c3d_place_of_residence: '',
        c3d_city: '',
        source: 'MANUAL',
        info_etsy_status: 'NO_TAX_INFO',
        ref_trusted_person_mid: this.state.ref_trusted_person_mid || '',
        ref_etsy_info_pack_mid: '',
        cmt_number: '',
        c3d_issue_date: '',
        c3d_expired_date: ''
      }
    });
  }

  handleCloseCreateModal = () => {
    this.setState({
      showCreateModal: false,
      createFormData: {
        full_name: '',
        full_name_english: '',
        c3d_number: '',
        c3d_dob: '',
        c3d_sex: 'MALE',
        c3d_place_of_origin: '',
        c3d_place_of_residence: '',
        c3d_city: '',
        source: 'MANUAL',
        info_etsy_status: 'NO_TAX_INFO',
        ref_trusted_person_mid: '',
        ref_etsy_info_pack_mid: '',
        cmt_number: '',
        c3d_issue_date: '',
        c3d_expired_date: ''
      }
    });
  }

  handleCreateInputChange = (field, value) => {
    this.setState({
      createFormData: {
        ...this.state.createFormData,
        [field]: value
      }
    });
  }

  handleEditInputChange = (field, value) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value
      }
    });
  }

  handleEtsyInfoPackClick = (refEtsyInfoPackMid) => {
    if (refEtsyInfoPackMid) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/etsy-info-pack-detail/${refEtsyInfoPackMid}`,
        iframeTitle: `Etsy Info Pack Detail - ${refEtsyInfoPackMid}`
      });
    }
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  }

  handleSaveEdit = async () => {
    const { selectedC3DInfo, editFormData } = this.state;
    
    if (!selectedC3DInfo || !selectedC3DInfo._id) {
      alert('Không tìm thấy thông tin C3D để cập nhật');
      return;
    }

    // Validation
    if (!editFormData.full_name) {
      alert('Vui lòng nhập tên đầy đủ');
      return;
    }
    if (!editFormData.c3d_number) {
      alert('Vui lòng nhập số C3D');
      return;
    }

    try {
      const token = getToken();
      const response = await fetch(`${getApiUrl()}/api/tkt1-c3d-info/${selectedC3DInfo._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(editFormData)
      });

      if (response.ok) {
        // Close modal
        this.handleCloseEditModal();
        
        // Refresh data
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1C3DInfos(apiQuery);
        
        alert('Cập nhật thông tin C3D thành công!');
      } else {
        const errorData = await response.json();
        alert(`Lỗi khi cập nhật C3D: ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error updating C3D:', error);
      alert('Lỗi khi cập nhật thông tin C3D. Vui lòng thử lại.');
    }
  }

  handleCreateC3D = async () => {
    const { createFormData } = this.state;
    
    // Validation
    if (!createFormData.full_name) {
      alert('Vui lòng nhập tên đầy đủ');
      return;
    }
    if (!createFormData.c3d_number) {
      alert('Vui lòng nhập số C3D');
      return;
    }

    try {
      const token = getToken();
      const response = await fetch(`${getApiUrl()}/api/tkt1-c3d-info`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(createFormData)
      });

      if (response.ok) {
        // Close modal
        this.handleCloseCreateModal();
        
        // Refresh data
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1C3DInfos(apiQuery);
        
        alert('Tạo C3D mới thành công!');
      } else {
        const errorData = await response.json();
        alert(`Lỗi khi tạo C3D: ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error creating C3D:', error);
      alert('Lỗi khi tạo C3D mới. Vui lòng thử lại.');
    }
  }

  // Update Trusted Person status
  handleUpdateTrustedPersonStatus = async () => {
    if (!this.state.ref_trusted_person_mid) {
      console.error('No ref_trusted_person_mid available');
      return;
    }

    try {
      // Calculate totals from current C3D data
      const { c3dInfos } = this.props;
      const matching_c3d_total = c3dInfos ? c3dInfos.length : 0;
      const matching_c3d_tax_total = c3dInfos ? c3dInfos.filter(info => 
        info.last_checked_tax && info.ref_trusted_person_mid === this.state.ref_trusted_person_mid
      ).length : 0;

      const updateData = {
        matching_c3d_total,
        matching_c3d_tax_total
      };

      const token = getToken();
      const response = await fetch(`${getApiUrl()}/api/tkt1-trusted-person-info/mid/${this.state.ref_trusted_person_mid}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(updateData)
      });

      if (response.ok) {
        alert(`Cập nhật thành công!\nTổng số C3D: ${matching_c3d_total}\nC3D đã kiểm tra thuế: ${matching_c3d_tax_total}`);
      } else {
        const errorData = await response.json();
        alert(`Lỗi cập nhật: ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error updating trusted person status:', error);
      alert('Lỗi khi cập nhật trạng thái');
    }
  }

  // Helper function to prepare API query (remove showColumns, show_sidebar and only include search_exact if explicitly enabled)
  prepareApiQuery = (query) => {
    const { showColumns, search, province, show_sidebar, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    // Add province filter if selected
    if (province && province.trim()) {
      apiQuery.province = province;
    }
    
    // Only add search_exact if user explicitly enabled it
    if (search && search.trim() && this.state.search_exact === true) {
      apiQuery.search_exact = true;
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      province: this.state.query.province
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1C3DInfos(apiQuery);
      localStorage.setItem('tkt1_c3d_query', JSON.stringify(trimmedQuery));
    })
  }

  updateUrl = (query) => {
    const { history } = this.props;
    // Remove showColumns and show_sidebar from URL query - they're only for client display
    const { showColumns, show_sidebar, ...urlQuery } = query;
    
    // Preserve ref_trusted_person_mid if it exists in state
    if (this.state.ref_trusted_person_mid) {
      urlQuery.ref_trusted_person_mid = this.state.ref_trusted_person_mid;
    }
    
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: '/admin/tkt1/c3d-database',
      search: queryStr,
    });
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    // Trim search value before sending to API
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      province: this.state.query.province
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery)
    this.props.getTKT1C3DInfos(apiQuery);
    localStorage.setItem('tkt1_c3d_query', JSON.stringify(trimmedQuery));
  }

  handleReload = () => {
    // Reload current data
    const apiQuery = this.prepareApiQuery(this.state.query);
    this.props.getTKT1C3DInfos(apiQuery);
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      province: this.state.query.province
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ c3dInfos: [] }, () => {
        this.updateUrl(trimmedQuery)
        this.props.getTKT1C3DInfos(apiQuery);
        localStorage.setItem('tkt1_c3d_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="4">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo tên, C3D number, địa chỉ..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Tỉnh thành</InputGroup.Text>
            <Form.Select
              value={this.state.query.province}
              onChange={this.handleProvinceChange}
            >
              <option value="">Tất cả</option>
              {vietnamAddressData.map((province) => {
                // Clean up display name by removing "Tỉnh", "Thành phố"
                const cleanDisplayName = province.Name
                  .replace(/^Tỉnh\s+/, '')
                  .replace(/^Thành phố\s+/, '')
                  .trim();
                
                return (
                  <option key={province.Id} value={cleanDisplayName}>
                    {cleanDisplayName}
                  </option>
                );
              })}
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="1" className="d-flex align-items-center">
          <Form.Check
            type="checkbox"
            id="search-exact"
            label="Tìm chính xác"
            checked={this.state.search_exact}
            onChange={this.handleSearchExactChange}
            className="ms-2"
          />
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp theo</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="full_name">Tên đầy đủ</option>
              <option value="c3d_number">Số C3D</option>
              <option value="c3d_dob">Ngày sinh</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={this.handleSelectSortOrder}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="1" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn me-2"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={this.handleReload}
            title="Tải lại dữ liệu"
          >
            <FaSync />
          </Button>
        </Col>
      </Row>
    </>
  }


  renderC3DInfoTable = () => {
    const { c3dInfos } = this.props; // Use props from Redux instead of state
    const { showColumns } = this.state; // Use separate showColumns state
    
    
    // Ensure c3dInfos is an array and filter out any null/undefined items
    const safeC3dInfos = Array.isArray(c3dInfos) ? c3dInfos.filter(info => info != null && typeof info === 'object') : [];
    
    // Early return if no data to prevent any rendering issues
    if (!safeC3dInfos || safeC3dInfos.length === 0) {
      return (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={{ width: '60px' }}>STT</th>
              {showColumns.full_name && <th>Tên đầy đủ</th>}
              {showColumns.full_name_english && <th>Tên tiếng Anh</th>}
              {showColumns.c3d_number && <th>Số C3D</th>}
              {showColumns.c3d_dob && <th>Ngày sinh</th>}
              {showColumns.c3d_sex && <th>Giới tính</th>}
              {showColumns.c3d_place_of_origin && <th>Nơi sinh</th>}
              {showColumns.c3d_place_of_residence && <th>Nơi cư trú</th>}
              {showColumns.c3d_city && <th>Thành phố</th>}
              {showColumns.tax_city && <th>Tax City</th>}
              {showColumns.source && <th>Nguồn</th>}
              {showColumns.info_etsy_status && <th>Trạng thái Etsy</th>}
              {showColumns.ref_trusted_person_mid && <th>MID người tin cậy</th>}
              {showColumns.ref_etsy_info_pack_mid && <th>MID Etsy Info Pack</th>}
              {showColumns.cmt_number && <th>Số CMT</th>}
              {showColumns.c3d_issue_date && <th>Ngày cấp C3D</th>}
              {showColumns.c3d_expired_date && <th>Ngày hết hạn C3D</th>}
              <th style={{ width: '150px' }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th style={{ width: '60px' }}>STT</th>
            {showColumns.full_name && <th>Tên đầy đủ</th>}
            {showColumns.full_name_english && <th>Tên tiếng Anh</th>}
            {showColumns.c3d_number && <th>Số C3D</th>}
            {showColumns.c3d_dob && <th>Ngày sinh</th>}
            {showColumns.c3d_sex && <th>Giới tính</th>}
            {showColumns.c3d_place_of_origin && <th>Nơi sinh</th>}
            {showColumns.c3d_place_of_residence && <th>Nơi cư trú</th>}
            {showColumns.c3d_city && <th>Thành phố</th>}
            {showColumns.tax_city && <th>Tax City</th>}
            {showColumns.source && <th>Nguồn</th>}
            {showColumns.info_etsy_status && <th>Trạng thái Etsy</th>}
            {showColumns.ref_trusted_person_mid && <th>MID người tin cậy</th>}
            {showColumns.ref_etsy_info_pack_mid && <th>MID Etsy Info Pack</th>}
            {showColumns.cmt_number && <th>Số CMT</th>}
            {showColumns.c3d_issue_date && <th>Ngày cấp C3D</th>}
            {showColumns.c3d_expired_date && <th>Ngày hết hạn C3D</th>}
            <th style={{ width: '150px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeC3dInfos.map((info, index) => {
            if (!info || typeof info !== 'object') return null; // Skip if info is undefined/null or not an object
              
              const isChecked = this.state.checkedTaxC3Ds.has(info.c3d_number);
              
              return (
                <tr key={info._id || index} style={{ backgroundColor: isChecked ? '#e8f5e8' : 'inherit' }}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.full_name && (
                    <td>
                      <div className="fw-bold">{info.full_name || '-'}</div>
                    </td>
                  )}
                  {showColumns.full_name_english && (
                    <td>{info.full_name_english || '-'}</td>
                  )}
                  {showColumns.c3d_number && (
                    <td>
                      {info.c3d_number ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{info.c3d_number}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(info.c3d_number)}
                            title="Copy C3D number"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.c3d_dob && (
                    <td>
                      {this.formatDate(info.c3d_dob)}
                    </td>
                  )}
                  {showColumns.c3d_sex && (
                    <td>{this.mapGender(info.c3d_sex)}</td>
                  )}
                  {showColumns.c3d_place_of_origin && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={info.c3d_place_of_origin}>
                        {info.c3d_place_of_origin || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.c3d_place_of_residence && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={info.c3d_place_of_residence}>
                        {info.c3d_place_of_residence || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.c3d_city && (
                    <td>{info.c3d_city || '-'}</td>
                  )}
                  {showColumns.tax_city && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={this.getTaxCities(info)}>
                        {this.getTaxCities(info)}
                      </div>
                    </td>
                  )}
                  {showColumns.source && (
                    <td>{info.source || '-'}</td>
                  )}
                  {showColumns.info_etsy_status && (
                    <td>
                      {info.info_etsy_status ? (
                        <Badge 
                          bg={
                            info.info_etsy_status === 'REGISTERED' ? 'success' :
                            info.info_etsy_status === 'SUSPENDED' ? 'danger' :
                            info.info_etsy_status === 'CANCEL' ? 'secondary' :
                            info.info_etsy_status === 'FOUND_TRUSTED_INFO' ? 'info' :
                            info.info_etsy_status === 'WAIT_FOR_TRUSTED_INFO' ? 'warning' :
                            'light'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapEtsyStatus(info.info_etsy_status)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.ref_trusted_person_mid && (
                    <td>
                      {info.ref_trusted_person_mid ? (
                        <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                          {info.ref_trusted_person_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.ref_etsy_info_pack_mid && (
                    <td>
                      {info.ref_etsy_info_pack_mid ? (
                        <Badge 
                          bg="success" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px', 
                            cursor: 'pointer' 
                          }}
                          onClick={() => this.handleEtsyInfoPackClick(info.ref_etsy_info_pack_mid)}
                          title="Click để xem chi tiết Etsy Info Pack"
                        >
                          {info.ref_etsy_info_pack_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.cmt_number && (
                    <td>{info.cmt_number || '-'}</td>
                  )}
                  {showColumns.c3d_issue_date && (
                    <td>
                      {this.formatDate(info.c3d_issue_date)}
                    </td>
                  )}
                  {showColumns.c3d_expired_date && (
                    <td>
                      {this.formatDate(info.c3d_expired_date)}
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ position: 'relative' }}>
                        <FaEye 
                          size={16} 
                          style={{ 
                            cursor: 'pointer', 
                            color: '#6c757d'
                          }}
                          title="Xem thông tin"
                          onClick={() => this.handleViewClick(info)}
                        />
                        {info.ref_trusted_person_mid && (
                          <span 
                            style={{
                              position: 'absolute',
                              top: '-4px',
                              right: '-4px',
                              width: '12px',
                              height: '12px',
                              backgroundColor: '#28a745',
                              borderRadius: '50%',
                              border: '2px solid white'
                            }}
                            title="Có Trusted Person"
                          />
                        )}
                      </div>
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(info)}
                      />
                      <FaQrcode 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d',
                          marginLeft: '5px'
                        }}
                        title="Xem mã QR"
                        onClick={() => this.handleQRClick(info)}
                      />
                      <span 
                        style={{ 
                          cursor: info.c3d_number ? 'pointer' : 'not-allowed',
                          opacity: info.c3d_number ? 1 : 0.5,
                          fontSize: '18px',
                          lineHeight: '1',
                          filter: isChecked ? 'brightness(1.2) saturate(1.5)' : 'none'
                        }}
                        title={isChecked ? "Đã kiểm tra thông tin thuế" : "Thông tin thuế KD"}
                        onClick={() => info.c3d_number && this.handleTaxIconClick(info.c3d_number)}
                      >
                        {isChecked ? '✅' : '🏛️'}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 C3D Database
              </h2>
            </Col>
            <Col className="text-end" md="auto">
              <Button 
                variant="primary" 
                onClick={this.handleCreateClick}
                className="me-2"
              >
                <i className="fas fa-plus me-1"></i>
                Thêm C3D mới
              </Button>
              {this.state.ref_trusted_person_mid && (
                <Button
                  variant="success"
                  size="sm"
                  onClick={this.handleUpdateTrustedPersonStatus}
                  title="Cập nhật trạng thái Trusted Person"
                >
                  <i className="fas fa-sync-alt"></i> Cập nhật trạng thái
                </Button>
              )}
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                {!this.state.ref_trusted_person_mid && (
                  <div className="d-inline-block ms-3">
                    <span className="me-2">Số bản ghi/trang:</span>
                    <Form.Select
                      size="sm"
                      value={this.state.query.itemsPerPage}
                      onChange={this.handleChangeItemsPerPage}
                      style={{ width: '100px', display: 'inline-block' }}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </Form.Select>
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.renderC3DInfoTable()}
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    full_name: 'Tên đầy đủ',
                    full_name_english: 'Tên tiếng Anh',
                    c3d_number: 'Số C3D',
                    c3d_dob: 'Ngày sinh',
                    c3d_sex: 'Giới tính',
                    c3d_place_of_origin: 'Nơi sinh',
                    c3d_place_of_residence: 'Nơi cư trú',
                    c3d_city: 'Thành phố',
                    tax_city: 'Tax City',
                    source: 'Nguồn',
                    info_etsy_status: 'Trạng thái Etsy',
                    ref_trusted_person_mid: 'MID người tin cậy',
                    ref_etsy_info_pack_mid: 'MID Etsy Info Pack',
                    cmt_number: 'Số CMT',
                    c3d_issue_date: 'Ngày cấp C3D',
                    c3d_expired_date: 'Ngày hết hạn C3D'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <C3DInfoModal
          show={this.state.showViewModal}
          onHide={this.handleCloseViewModal}
          c3dInfo={this.state.selectedC3DInfo}
          isEditMode={false}
          refTrustedPersonMid={this.state.ref_trusted_person_mid}
        />

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa C3D</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên đầy đủ <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.full_name}
                      onChange={(e) => this.handleEditInputChange('full_name', e.target.value)}
                      placeholder="Nhập tên đầy đủ"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên tiếng Anh</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.full_name_english}
                      onChange={(e) => this.handleEditInputChange('full_name_english', e.target.value)}
                      placeholder="Nhập tên tiếng Anh"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Số C3D <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.c3d_number}
                      onChange={(e) => this.handleEditInputChange('c3d_number', e.target.value)}
                      placeholder="Nhập số C3D"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày sinh</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.formatDateForInput(this.state.editFormData.c3d_dob)}
                      onChange={(e) => this.handleEditInputChange('c3d_dob', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Giới tính</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.c3d_sex}
                      onChange={(e) => this.handleEditInputChange('c3d_sex', e.target.value)}
                    >
                      <option value="MALE">Nam</option>
                      <option value="FEMALE">Nữ</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Thành phố</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.c3d_city}
                      onChange={(e) => this.handleEditInputChange('c3d_city', e.target.value)}
                      placeholder="Nhập thành phố"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Nơi sinh</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.c3d_place_of_origin}
                      onChange={(e) => this.handleEditInputChange('c3d_place_of_origin', e.target.value)}
                      placeholder="Nhập nơi sinh"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Nơi cư trú</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.c3d_place_of_residence}
                      onChange={(e) => this.handleEditInputChange('c3d_place_of_residence', e.target.value)}
                      placeholder="Nhập nơi cư trú"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Nguồn</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.source}
                      onChange={(e) => this.handleEditInputChange('source', e.target.value)}
                    >
                      <option value="MANUAL">Thủ công</option>
                      <option value="IMPORT">Nhập khẩu</option>
                      <option value="API">API</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái Etsy</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.info_etsy_status}
                      onChange={(e) => this.handleEditInputChange('info_etsy_status', e.target.value)}
                    >
                      <option value="NO_TAX_INFO">Chưa có thông tin thuế</option>
                      <option value="WAIT_FOR_TRUSTED_INFO">Chờ thông tin người tin cậy</option>
                      <option value="FOUND_TRUSTED_INFO">Đã tìm thấy người tin cậy</option>
                      <option value="REGISTERED">Đã đăng ký</option>
                      <option value="SUSPENDED">Bị tạm dừng</option>
                      <option value="CANCEL">Đã hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>MID người tin cậy</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_trusted_person_mid}
                      onChange={(e) => this.handleEditInputChange('ref_trusted_person_mid', e.target.value)}
                      placeholder="Nhập MID người tin cậy"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>MID Etsy Info Pack</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_etsy_info_pack_mid}
                      onChange={(e) => this.handleEditInputChange('ref_etsy_info_pack_mid', e.target.value)}
                      placeholder="Nhập MID Etsy Info Pack"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Số CMT</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.cmt_number}
                      onChange={(e) => this.handleEditInputChange('cmt_number', e.target.value)}
                      placeholder="Nhập số CMT"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày cấp C3D</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.formatDateForInput(this.state.editFormData.c3d_issue_date)}
                      onChange={(e) => this.handleEditInputChange('c3d_issue_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày hết hạn C3D</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.formatDateForInput(this.state.editFormData.c3d_expired_date)}
                      onChange={(e) => this.handleEditInputChange('c3d_expired_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveEdit}>
              Lưu thay đổi
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Create Modal */}
        <Modal show={this.state.showCreateModal} onHide={this.handleCloseCreateModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thêm C3D mới</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên đầy đủ <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.full_name}
                      onChange={(e) => this.handleCreateInputChange('full_name', e.target.value)}
                      placeholder="Nhập tên đầy đủ"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên tiếng Anh</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.full_name_english}
                      onChange={(e) => this.handleCreateInputChange('full_name_english', e.target.value)}
                      placeholder="Nhập tên tiếng Anh"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Số C3D <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.c3d_number}
                      onChange={(e) => this.handleCreateInputChange('c3d_number', e.target.value)}
                      placeholder="Nhập số C3D"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày sinh</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.formatDateForInput(this.state.createFormData.c3d_dob)}
                      onChange={(e) => this.handleCreateInputChange('c3d_dob', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Giới tính</Form.Label>
                    <Form.Select
                      value={this.state.createFormData.c3d_sex}
                      onChange={(e) => this.handleCreateInputChange('c3d_sex', e.target.value)}
                    >
                      <option value="MALE">Nam</option>
                      <option value="FEMALE">Nữ</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Thành phố</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.c3d_city}
                      onChange={(e) => this.handleCreateInputChange('c3d_city', e.target.value)}
                      placeholder="Nhập thành phố"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Nơi sinh</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.c3d_place_of_origin}
                      onChange={(e) => this.handleCreateInputChange('c3d_place_of_origin', e.target.value)}
                      placeholder="Nhập nơi sinh"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Nơi cư trú</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.c3d_place_of_residence}
                      onChange={(e) => this.handleCreateInputChange('c3d_place_of_residence', e.target.value)}
                      placeholder="Nhập nơi cư trú"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Nguồn</Form.Label>
                    <Form.Select
                      value={this.state.createFormData.source}
                      onChange={(e) => this.handleCreateInputChange('source', e.target.value)}
                    >
                      <option value="MANUAL">Thủ công</option>
                      <option value="IMPORT">Nhập khẩu</option>
                      <option value="API">API</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái Etsy</Form.Label>
                    <Form.Select
                      value={this.state.createFormData.info_etsy_status}
                      onChange={(e) => this.handleCreateInputChange('info_etsy_status', e.target.value)}
                    >
                      <option value="NO_TAX_INFO">Chưa có thông tin thuế</option>
                      <option value="WAIT_FOR_TRUSTED_INFO">Chờ thông tin người tin cậy</option>
                      <option value="FOUND_TRUSTED_INFO">Đã tìm thấy người tin cậy</option>
                      <option value="REGISTERED">Đã đăng ký</option>
                      <option value="SUSPENDED">Bị tạm dừng</option>
                      <option value="CANCEL">Đã hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>MID người tin cậy</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.ref_trusted_person_mid}
                      onChange={(e) => this.handleCreateInputChange('ref_trusted_person_mid', e.target.value)}
                      placeholder="Nhập MID người tin cậy"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>MID Etsy Info Pack</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.ref_etsy_info_pack_mid}
                      onChange={(e) => this.handleCreateInputChange('ref_etsy_info_pack_mid', e.target.value)}
                      placeholder="Nhập MID Etsy Info Pack"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Số CMT</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.cmt_number}
                      onChange={(e) => this.handleCreateInputChange('cmt_number', e.target.value)}
                      placeholder="Nhập số CMT"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày cấp C3D</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.formatDateForInput(this.state.createFormData.c3d_issue_date)}
                      onChange={(e) => this.handleCreateInputChange('c3d_issue_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày hết hạn C3D</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.formatDateForInput(this.state.createFormData.c3d_expired_date)}
                      onChange={(e) => this.handleCreateInputChange('c3d_expired_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseCreateModal}>
              Hủy
            </Button>
            <Button variant="success" onClick={this.handleCreateC3D}>
              <i className="fas fa-plus me-1"></i>
              Tạo C3D mới
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
          showSidebar={false}
        />

        {/* QR Code Modal */}
        <Modal show={this.state.showQRModal} onHide={this.handleCloseQRModal} size="md">
          <Modal.Header closeButton>
            <Modal.Title>Mã QR - Thông tin C3D</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedC3DInfo && (
              <div>
                <Row>
                <Col md="6">
                  <Card className="h-100">
                    <Card.Header className="bg-success text-white" style={{ padding: '0.5rem 0.75rem' }}>
                      <h6 className="mb-0">
                        <i className="fas fa-qrcode me-2"></i>
                        Mã QR C3D
                      </h6>
                    </Card.Header>
                    <Card.Body className="text-center" style={{ padding: '0.75rem' }}>
                      <div className="mb-2">
                        <small className="text-muted">{this.state.selectedC3DInfo.c3d_number}</small>
                      </div>
                      <div className="mb-3" id="qr-code-container">
                        <QRCodeSVG
                          value={this.generateQRData(this.state.selectedC3DInfo)}
                          size={150}
                          style={{ height: "auto", maxWidth: "100%", width: "100%", backgroundColor: 'transparent' }}
                        />
                      </div>
                      <div className="d-flex gap-2 justify-content-center">
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => this.copyToClipboard(this.generateQRData(this.state.selectedC3DInfo))}
                        >
                          <FaCopy size={12} className="me-1" />
                          Copy
                        </Button>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => this.downloadQRAsPNG()}
                        >
                          <i className="fas fa-download me-1"></i>
                          PNG
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md="6">
                  <Card className="h-100">
                    <Card.Header className="bg-info text-white" style={{ padding: '0.5rem 0.75rem' }}>
                      <h6 className="mb-0">
                        <i className="fas fa-code me-2"></i>
                        Dữ liệu QR
                      </h6>
                    </Card.Header>
                    <Card.Body style={{ padding: '0.75rem' }}>
                      <Form.Control
                        as="textarea"
                        rows={6}
                        value={this.generateQRData(this.state.selectedC3DInfo)}
                        readOnly
                        style={{ fontSize: '11px', fontFamily: 'monospace', resize: 'none' }}
                      />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>


              <Row className="mt-3">
                <Col>
                  <Card>
                    <Card.Header className="bg-warning text-dark" style={{ padding: '0.5rem 0.75rem' }}>
                      <h6 className="mb-0">
                        <i className="fas fa-passport me-2"></i>
                        MRZ (Machine Readable Zone) - TD1 (3x30)
                      </h6>
                    </Card.Header>
                    <Card.Body style={{ padding: '0.75rem' }}>
                      {(() => {
                        const mrz = this.generateMRZ(this.state.selectedC3DInfo);
                        if (!mrz) {
                          return (
                            <div className="text-center text-muted">
                              <i className="fas fa-exclamation-triangle me-2"></i>
                              Không thể tạo MRZ - thiếu thông tin hoặc định dạng không đúng
                            </div>
                          );
                        }
                        return (
                          <div>
                            <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h6 className="mb-0">MRZ Lines (3x30 characters):</h6>
                                  <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => this.copyToClipboard(mrz.allLines)}
                                  >
                                    <FaCopy size={12} className="me-1" />
                                    Copy All
                                  </Button>
                                </div>
                                <div className="bg-light p-3 rounded" style={{ fontFamily: 'monospace', fontSize: '14px' }}>
                                  <div className="mb-1">
                                    <span className="text-muted me-2">1:</span>
                                    <span className="text-primary">{mrz.line1}</span>
                                    <FaCopy 
                                      size={12} 
                                      className="ms-2 text-muted" 
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => this.copyToClipboard(mrz.line1)}
                                      title="Copy Line 1"
                                    />
                                  </div>
                                  <div className="mb-1">
                                    <span className="text-muted me-2">2:</span>
                                    <span className="text-success">{mrz.line2}</span>
                                    <FaCopy 
                                      size={12} 
                                      className="ms-2 text-muted" 
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => this.copyToClipboard(mrz.line2)}
                                      title="Copy Line 2"
                                    />
                                  </div>
                                  <div>
                                    <span className="text-muted me-2">3:</span>
                                    <span className="text-info">{mrz.line3}</span>
                                    <FaCopy 
                                      size={12} 
                                      className="ms-2 text-muted" 
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => this.copyToClipboard(mrz.line3)}
                                      title="Copy Line 3"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <small className="text-muted">
                                    <strong>Document Info:</strong><br/>
                                    DocNum: {mrz.computed.docnum9_field} (CD: {mrz.computed.docnum_cd})<br/>
                                    Full12: {mrz.computed.full12} (CD: {mrz.computed.full12_cd})
                                  </small>
                                </div>
                                <div className="col-md-6">
                                  <small className="text-muted">
                                    <strong>Dates:</strong><br/>
                                    DOB: {mrz.computed.dob6} (CD: {mrz.computed.dob_cd})<br/>
                                    Expiry: {mrz.computed.expiry6} (CD: {mrz.computed.expiry_cd})
                                  </small>
                                </div>
                              </div>
                            </div>
                          );
                        })()}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseQRModal}>
              Đóng
            </Button>
          </Modal.Footer>
          </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    c3dInfos: state.tkt1C3DInfoReducer.c3dInfos,
    totalCount: state.tkt1C3DInfoReducer.totalCount
  };
};

export default connect(mapStateToProps, { getTKT1C3DInfos })(TKT1C3DInfo);
